export class SyncCommandResult {

    public orderId  : string = '';

    public wasAttempted : boolean = false;
    
    public isLoading : boolean = false;

    public error : string|undefined = undefined;
}
